import { Lang } from '../types'

const T = {
  // Navigation
  home:         { ru: 'Главная',            uz: 'Bosh sahifa' },
  catalog:      { ru: 'Каталог',            uz: 'Katalog' },
  myOrders:     { ru: 'Мои заявки',         uz: 'Arizalarim' },
  profile:      { ru: 'Профиль',            uz: 'Profil' },
  orders:       { ru: 'Заявки',             uz: 'Arizalar' },
  payments:     { ru: 'Платежи',            uz: 'To\'lovlar' },
  clients:      { ru: 'Клиенты',            uz: 'Mijozlar' },
  products:     { ru: 'Товары',             uz: 'Mahsulotlar' },
  more:         { ru: 'Ещё',               uz: 'Ko\'proq' },
  settings:     { ru: 'Настройки',          uz: 'Sozlamalar' },
  registry:     { ru: 'Реестр',             uz: 'Reyestr' },
  overview:     { ru: 'Обзор',              uz: 'Ko\'rinish' },

  // Common actions
  loading:      { ru: 'Загрузка...',        uz: 'Yuklanmoqda...' },
  error:        { ru: 'Ошибка',             uz: 'Xato' },
  save:         { ru: 'Сохранить',          uz: 'Saqlash' },
  cancel:       { ru: 'Отмена',             uz: 'Bekor qilish' },
  confirm:      { ru: 'Подтвердить',        uz: 'Tasdiqlash' },
  reject:       { ru: 'Отклонить',          uz: 'Rad etish' },
  approve:      { ru: 'Одобрить',           uz: 'Tasdiqlash' },
  activate:     { ru: 'Активировать',       uz: 'Faollashtirish' },
  block:        { ru: 'Заблокировать',      uz: 'Bloklash' },
  unblock:      { ru: 'Разблокировать',     uz: 'Blokdan chiqarish' },
  search:       { ru: 'Поиск',              uz: 'Qidirish' },
  close:        { ru: 'Закрыть',            uz: 'Yopish' },
  add:          { ru: 'Добавить',           uz: 'Qo\'shish' },
  edit:         { ru: 'Редактировать',      uz: 'Tahrirlash' },
  delete:       { ru: 'Удалить',            uz: 'O\'chirish' },
  yes:          { ru: 'Да',                 uz: 'Ha' },
  no:           { ru: 'Нет',                uz: 'Yo\'q' },
  export:       { ru: 'Экспорт',            uz: 'Eksport' },
  back:         { ru: 'Назад',              uz: 'Orqaga' },
  apply:        { ru: 'Применить',          uz: 'Qo\'llash' },
  deactivate:   { ru: 'Деактивировать',     uz: 'O\'chirish' },
  optional:     { ru: 'Необязательно',      uz: 'Ixtiyoriy' },

  // Status filter tabs
  all:          { ru: 'Все',                uz: 'Barchasi' },
  tabNew:       { ru: 'Новые',              uz: 'Yangi' },
  tabReviewing: { ru: 'Проверка',           uz: 'Ko\'rib chiqish' },
  tabApproved:  { ru: 'Одобрены',           uz: 'Tasdiqlangan' },
  tabActive:    { ru: 'Активные',           uz: 'Faol' },
  tabClosed:    { ru: 'Закрытые',           uz: 'Yopilgan' },
  tabRejected:  { ru: 'Отказ',              uz: 'Rad etilgan' },

  // Products
  price:        { ru: 'Цена',               uz: 'Narx' },
  allCategories:{ ru: 'Все',                uz: 'Barchasi' },
  noProducts:   { ru: 'Нет товаров',        uz: 'Mahsulotlar yo\'q' },
  noData:       { ru: 'Нет данных',         uz: 'Ma\'lumot yo\'q' },
  productsWord: { ru: 'товаров',            uz: 'ta mahsulot' },
  ordersWord:   { ru: 'заявок',             uz: 'ta ariza' },
  inactive:     { ru: 'Неактивен',          uz: 'Faol emas' },
  deactivateConfirm: { ru: 'Деактивировать товар?', uz: 'Mahsulotni o\'chirish?' },
  category:     { ru: 'Категория',          uz: 'Kategoriya' },
  noCategory:   { ru: '— Без категории —', uz: '— Kategoriyasiz —' },
  nameRu:       { ru: 'Название (RU)',      uz: 'Nomi (RU)' },
  nameUz:       { ru: 'Название (UZ)',      uz: 'Nomi (UZ)' },
  descriptionRu:{ ru: 'Описание (RU)',      uz: 'Tavsif (RU)' },
  descriptionUz:{ ru: 'Описание (UZ)',      uz: 'Tavsif (UZ)' },
  productPhoto: { ru: 'Фото товара',        uz: 'Mahsulot rasmi' },
  productAdded: { ru: 'Товар добавлен',     uz: 'Mahsulot qo\'shildi' },
  productSaved: { ru: 'Сохранено',          uz: 'Saqlandi' },
  productDeactivated: { ru: 'Товар деактивирован', uz: 'Mahsulot o\'chirildi' },
  photoUploaded:{ ru: 'Фото загружено',     uz: 'Rasm yuklandi' },
  uploadError:  { ru: 'Ошибка загрузки',   uz: 'Yuklash xatosi' },
  installmentFrom: { ru: 'рассрочка от 0%', uz: 'muddatli to\'lov 0%dan' },

  // Calculator / Order
  downPayment:  { ru: 'Первоначальный взнос', uz: 'Boshlang\'ich to\'lov' },
  months:       { ru: 'Срок (мес)',         uz: 'Muddat (oy)' },
  monthly:      { ru: 'В месяц',            uz: 'Oylik' },
  total:        { ru: 'Итого',              uz: 'Jami' },
  rate:         { ru: 'Ставка',             uz: 'Stavka' },
  loanAmount:   { ru: 'Сумма рассрочки',     uz: 'Muddatli to\'lov summasi' },
  submitOrder:  { ru: 'Оформить рассрочку', uz: 'Bo\'lib to\'lashga rasmiylashtirish' },
  orderCreated: { ru: 'Заявка создана!',    uz: 'Ariza yaratildi!' },
  loanTerm:     { ru: 'Срок рассрочки',     uz: 'Bo\'lib to\'lash muddati' },
  minLabel:     { ru: 'МИН',               uz: 'MIN' },
  monthlyPayment: { ru: 'Ежемесячный платёж', uz: 'Oylik to\'lov' },
  sum:          { ru: 'сум',               uz: 'so\'m' },
  paymentsWord: { ru: 'платежей',           uz: 'ta to\'lov' },
  monthsShort:  { ru: 'мес.',              uz: 'oy' },
  perMonthShort:{ ru: '/мес',              uz: '/oy' },
  orderWord:    { ru: 'Заявка',             uz: 'Ariza' },

  // Order details
  registryNum:  { ru: 'Номер заявки',       uz: 'Ariza raqami' },
  status:       { ru: 'Статус',             uz: 'Holat' },
  paymentSchedule: { ru: 'График платежей', uz: 'To\'lov jadvali' },
  paymentNum:   { ru: 'Платёж',             uz: 'To\'lov' },
  dueDate:      { ru: 'Срок',               uz: 'Muddati' },
  paidAt:       { ru: 'Оплачен',            uz: 'To\'landi' },
  payNow:       { ru: 'Оплатить',           uz: 'To\'lash' },
  submittedAt:  { ru: 'Подана',             uz: 'Topshirildi' },
  approvedAt:   { ru: 'Одобрена',           uz: 'Tasdiqlandi' },
  activatedAt:  { ru: 'Активирована',       uz: 'Faollashtirildi' },
  nextPayment:  { ru: 'Следующий платёж',   uz: 'Keyingi to\'lov' },
  progress:     { ru: 'Прогресс',           uz: 'Jarayon' },
  paidWord:     { ru: 'оплачено',           uz: 'to\'langan' },
  remaining:    { ru: 'осталось',           uz: 'qoldi' },
  conditions:   { ru: 'Условия',            uz: 'Shartlar' },
  until:        { ru: 'До',                 uz: 'Gacha' },
  orderApproved:  { ru: 'Заявка одобрена',  uz: 'Ariza tasdiqlandi' },
  orderRejected:  { ru: 'Заявка отклонена', uz: 'Ariza rad etildi' },
  orderActivated: { ru: 'Заявка активирована', uz: 'Ariza faollashtirildi' },

  // Submit payment
  paymentNumLabel: { ru: 'Платёж №',        uz: 'To\'lov №' },
  amountToPay:  { ru: 'Сумма к оплате',     uz: 'To\'lov miqdori' },
  paymentDeadline: { ru: 'Срок оплаты',     uz: 'To\'lov muddati' },
  orderLabel:   { ru: 'Заявка',             uz: 'Ariza' },
  transferPayment: { ru: '🏦 Оплата переводом', uz: '🏦 O\'tkazma orqali to\'lov' },
  cardNumber:   { ru: 'Номер карты',        uz: 'Karta raqami' },
  askManager:   { ru: 'Уточните реквизиты у менеджера', uz: 'Menejerdan rekvizitlarni so\'rang' },
  cashPayment:  { ru: '💵 Оплата наличными', uz: '💵 Naqd to\'lov' },
  cashInstruction: { ru: 'Сообщите менеджеру о готовности оплатить наличными. Укажите номер заявки:', uz: 'Menejerga naqd to\'lashga tayyorligingiz haqida xabar bering. Ariza raqamini ko\'rsating:' },
  paymentStatusNote: { ru: 'Статус платежа обновится после подтверждения менеджером', uz: 'To\'lov holati menejer tasdiqlashidan keyin yangilanadi' },
  cardNumberCopied: { ru: 'Номер карты скопирован', uz: 'Karta raqami nusxalandi' },
  transferReceiptHint: { ru: 'После перевода отправьте квитанцию боту с указанием заявки', uz: 'O\'tkazma o\'tkazganingizdan so\'ng kvitansiyani botga ariza raqamini ko\'rsatib yuboring' },
  transferNote: { ru: 'Для оплаты переводом отправьте квитанцию боту', uz: 'O\'tkazma uchun kvitansiyani botga yuboring' },
  submitPayment:{ ru: 'Подтвердить оплату',  uz: 'To\'lovni tasdiqlash' },
  paymentMethod:{ ru: 'Способ оплаты',       uz: 'To\'lov usuli' },
  cash:         { ru: 'Наличные',            uz: 'Naqd' },
  transfer:     { ru: 'Перевод',             uz: 'O\'tkazma' },

  // Profile
  language:     { ru: 'Язык',               uz: 'Til' },
  russian:      { ru: 'Русский',            uz: 'Rus tili' },
  uzbek:        { ru: 'Узбекский',          uz: 'O\'zbek tili' },
  verified:     { ru: 'Верифицирован',      uz: 'Tasdiqlangan' },
  notVerified:  { ru: 'Не верифицирован',   uz: 'Tasdiqlanmagan' },
  discount:     { ru: 'Скидка',             uz: 'Chegirma' },
  passportReceived: { ru: 'Фото паспорта получено — ожидает проверки менеджером', uz: 'Pasport rasmi olindi — menejer tekshirishini kutmoqda' },
  passportHint: { ru: 'Отправьте фото паспорта боту для верификации', uz: 'Tasdiqlash uchun pasport rasmini botga yuboring' },

  // Admin — common
  noOrders:     { ru: 'Нет заявок',         uz: 'Arizalar yo\'q' },
  noPayments:   { ru: 'Нет платежей',       uz: 'To\'lovlar yo\'q' },
  noClients:    { ru: 'Нет клиентов',       uz: 'Mijozlar yo\'q' },
  customRate:   { ru: 'Своя ставка (%)',    uz: 'Maxsus stavka (%)' },
  note:         { ru: 'Примечание',         uz: 'Izoh' },
  reason:       { ru: 'Причина',            uz: 'Sabab' },
  rejectReason: { ru: 'Причина отказа',     uz: 'Rad etish sababi' },
  discountPct:  { ru: 'Скидка (%)',         uz: 'Chegirma (%)' },
  role:         { ru: 'Роль',               uz: 'Rol' },
  permissions:  { ru: 'Права',              uz: 'Huquqlar' },

  // Admin — order detail
  firstPaymentDate: { ru: 'Дата первого платежа', uz: 'Birinchi to\'lov sanasi' },
  setFirstPaymentDate: { ru: 'Сохранить дату', uz: 'Sanani saqlash' },
  firstPaymentDateSaved: { ru: 'Дата сохранена', uz: 'Sana saqlandi' },
  activateRequiresDate: { ru: 'Укажите дату первого платежа', uz: 'Birinchi to\'lov sanasini kiriting' },
  clientLabel:  { ru: 'Клиент',             uz: 'Mijoz' },
  productPrice: { ru: 'Цена товара',        uz: 'Mahsulot narxi' },
  priceAfterDiscount: { ru: 'После скидки', uz: 'Chegirmadan keyin' },
  approveOrder: { ru: 'Одобрить заявку',    uz: 'Arizani tasdiqlash' },
  rejectOrder:  { ru: 'Отклонить заявку',   uz: 'Arizani rad etish' },
  specifyReason:{ ru: 'Укажите причину',    uz: 'Sababni ko\'rsating' },

  // Admin — user detail
  telegramId:   { ru: 'Telegram ID',        uz: 'Telegram ID' },
  createdBy:    { ru: 'Создан администратором', uz: 'Admin tomonidan yaratilgan' },
  verificationLabel: { ru: 'Верификация',   uz: 'Tasdiqlash' },
  activeStatus: { ru: 'Активен',            uz: 'Faol' },
  blockedStatus:{ ru: '🚫 Заблокирован',    uz: '🚫 Bloklangan' },
  registrationDate: { ru: 'Регистрация',    uz: 'Ro\'yxatdan o\'tish' },
  lastVisit:    { ru: 'Последний визит',     uz: 'Oxirgi tashrif' },
  passportLabel:{ ru: 'Паспорт',            uz: 'Pasport' },
  passportUploaded: { ru: '📎 Загружен, ожидает', uz: '📎 Yuklangan, kutmoqda' },
  blockUserSuccess: { ru: 'Пользователь заблокирован', uz: 'Foydalanuvchi bloklangan' },
  unblockUserSuccess: { ru: 'Пользователь разблокирован', uz: 'Foydalanuvchi blokdan chiqarildi' },
  discountApplied: { ru: 'Скидка применена', uz: 'Chegirma qo\'llandi' },
  discountRemoved: { ru: 'Скидка удалена',  uz: 'Chegirma o\'chirildi' },
  roleChanged:  { ru: 'Роль изменена',      uz: 'Rol o\'zgartirildi' },

  // Admin — payments
  paymentConfirmed: { ru: 'Платёж подтверждён', uz: 'To\'lov tasdiqlandi' },
  paymentRejected:  { ru: 'Платёж отклонён',    uz: 'To\'lov rad etildi' },
  awaitingConfirmation: { ru: 'На подтверждении', uz: 'Tasdiqlanmoqda' },

  // Admin — registry
  ordersCount:  { ru: 'Заявок:',            uz: 'Arizalar:' },
  activeCount:  { ru: 'Активных:',          uz: 'Faol:' },
  debtLabel:    { ru: 'Долг:',              uz: 'Qarz:' },
  remainingLabel: { ru: 'Остаток:',         uz: 'Qoldiq:' },
  overdueDays:  { ru: 'дн. просрочки',      uz: 'kun kechikish' },

  // Custom order
  customOrderTitle: { ru: 'Отправить заявку',       uz: 'Ariza qoldirish' },
  customOrder:      { ru: 'Отправить заявку',       uz: 'Ariza qoldirish' },
  productName:      { ru: 'Название товара',        uz: 'Mahsulot nomi' },
  enterComment:     { ru: 'Комментарий',            uz: 'Izoh' },
  enterPrice:       { ru: 'Введите стоимость',      uz: 'Narxni kiriting' },
  enterProductName: { ru: 'Введите название товара', uz: 'Mahsulot nomini kiriting' },
  openOrderForClient: { ru: 'Открыть заявку',        uz: 'Ariza ochish' },
  orderSentToClient:  { ru: 'Заявка отправлена клиенту на подтверждение', uz: 'Ariza mijozga tasdiqlash uchun yuborildi' },

  // Admin — settings
  settingsSaved: { ru: 'Настройки сохранены', uz: 'Sozlamalar saqlandi' },
  interestRates:{ ru: 'Ставки рассрочки (%)',    uz: 'Muddatli to\'lov stavkalari (%)' },
  rateUpTo3:    { ru: '≤ 3 мес.',           uz: '≤ 3 oy' },
  rateUpTo6:    { ru: '≤ 6 мес.',           uz: '≤ 6 oy' },
  rateUpTo9:    { ru: '≤ 9 мес.',           uz: '≤ 9 oy' },
  rateFrom10:   { ru: '≥ 10 мес.',          uz: '≥ 10 oy' },
  general:      { ru: 'Общие',              uz: 'Umumiy' },
  minDownPaymentLabel: { ru: 'Мин. первый взнос (%)', uz: 'Min. boshlang\'ich to\'lov (%)' },
  maxTermLabel: { ru: 'Макс. срок (мес)',   uz: 'Maks. muddat (oy)' },
  cardDetails:  { ru: 'Реквизиты карты',    uz: 'Karta rekvizitlari' },
  exchangeRate: { ru: 'Курс доллара',       uz: 'Dollar kursi' },
  cardHolder:   { ru: 'Владелец',           uz: 'Karta egasi' },
  superadminOnly: { ru: 'Изменять настройки может только Superadmin', uz: 'Sozlamalarni faqat Superadmin o\'zgartira oladi' },

  // Tier limits
  tierLimits:     { ru: 'Лимиты по уровням ($)',       uz: 'Darajalar bo\'yicha limitlar ($)' },
  limitBronze:    { ru: 'Bronze лимит',                uz: 'Bronze limiti' },
  limitSilver:    { ru: 'Silver лимит',                uz: 'Silver limiti' },
  limitGold:      { ru: 'Gold лимит',                  uz: 'Gold limiti' },
  supportUsername:{ ru: 'Username поддержки (без @)',   uz: 'Qo\'llab-quvvatlash username (@siz)' },
  support:        { ru: 'Поддержка',                   uz: 'Qo\'llab-quvvatlash' },

  // Admin — dashboard
  dashTitle:      { ru: 'Дашборд',                     uz: 'Boshqaruv paneli' },
  dueThisMonth:   { ru: 'Должно прийти в этом месяце', uz: 'Bu oy tushishi kerak' },
  planLabel:      { ru: 'План',                        uz: 'Reja' },
  factLabel:      { ru: 'Факт',                        uz: 'Fakt' },
  portfolio:      { ru: 'Кредитный портфель',          uz: 'Kredit portfeli' },
  totalOrders:    { ru: 'Всего заявок',                uz: 'Jami arizalar' },
  totalClients:   { ru: 'Всего клиентов',              uz: 'Jami mijozlar' },
  conversion:     { ru: 'Конверсия',                   uz: 'Konversiya' },
  avgRate:        { ru: 'Средняя ставка',              uz: 'O\'rtacha stavka' },
  avgMonthlyPayment: { ru: 'Средний платёж/мес',       uz: 'O\'rtacha oylik to\'lov' },
  expectedIncome: { ru: 'Ожидаемый доход',             uz: 'Kutilayotgan daromad' },
  newThisMonth:   { ru: 'Новых за месяц',              uz: 'Bu oy yangi' },
  statusBreakdown:{ ru: 'По статусам',                 uz: 'Holat bo\'yicha' },
  ordersTrend:    { ru: 'Динамика заявок',             uz: 'Arizalar dinamikasi' },
  overdue:        { ru: 'Просрочка',                   uz: 'Kechikish' },
  tierBreakdown:  { ru: 'По уровням',                  uz: 'Darajalar bo\'yicha' },
  blockedCount:   { ru: 'Заблокировано',               uz: 'Bloklangan' },
  verifiedCount:  { ru: 'Верифицировано',              uz: 'Tasdiqlangan' },
  allOrders:      { ru: 'Все заявки →',                uz: 'Barcha arizalar →' },
  last30days:     { ru: '30 дней',                     uz: '30 kun' },
  thisMonth:      { ru: 'В этом месяце',                uz: 'Shu oyda' },
  paymentsThisMonth: { ru: 'Платежи в этом месяце',      uz: 'Bu oy to\'lovlari' },
} as const

type Key = keyof typeof T

export function t(lang: Lang, key: Key): string {
  return T[key][lang]
}

export function useT(lang: Lang) {
  return (key: Key) => T[key][lang]
}
